import { render, staticRenderFns } from "./ModalAuthentication.vue?vue&type=template&id=d5c3334a&"
import script from "./ModalAuthentication.vue?vue&type=script&lang=ts&"
export * from "./ModalAuthentication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports